module.exports = __webpack_public_path__ + "img/product8.abfd94c2.jpg";